/**
* Dtails+ Toggle read more less
*/

var toggleccessibility = function (event) {
  if (event.getAttribute('aria-expanded') === 'true') {
    event.setAttribute('aria-expanded', false);
  } else {
    event.setAttribute('aria-expanded', true);
  }
};

// Listen for click on the document
document.addEventListener('click', function (event) {

  // Bail if our clicked element doesn't match
  var trigger = event.target.closest('[data-dtails-toggle-read-more-less]');
  if (!trigger) return;

  // Get the target content
  var content = document.querySelector('#' + trigger.getAttribute('aria-controls'));
  if (!content) return;

  // Get the target ID from the data attribute
  var contentTeaser = document.querySelector('#' + trigger.getAttribute('data-dtails-toggle-read-more-less'));
  if (!contentTeaser) return;

  // Prevent default link behavior
  event.preventDefault();

  // Toggle Accessbility
  toggleccessibility(trigger);

  // Toggle our content
  content.classList.toggle('dtails-hidden');
  contentTeaser.classList.toggle('dtails-hidden');

  // Toggle trigger read more less text
  trigger.querySelector('[data-dtails-toggle-read-less]').classList.toggle('dtails-hidden')
  trigger.querySelector('[data-dtails-toggle-read-more]').classList.toggle('dtails-hidden')

});

// document ready
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('button.countries-list__item').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      let country = e.currentTarget.value;
      let currency = e.currentTarget.getAttribute('data-currency');
      post('/localization', {
        form_type: 'localization',
        _method: 'put',
        locale_code: country,
        currency_code: currency
      })
    })
  });

  /**
   * sends a request to the specified url from a form. this will change the window location.
   * @param {string} path the path to send the post request to
   * @param {object} params the parameters to add to the url
   * @param {string} [method=post] the method to use on the form
   */

  function post(path, params, method='post') {

    // The rest of this code assumes you are not using a library.
    // It can be made less verbose if you use one.
    const form = document.createElement('form');
    form.method = method;
    form.action = path;

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];

        form.appendChild(hiddenField);
      }
    }

    document.body.appendChild(form);
    form.submit();
  }
});
